import useCenterBaseList from "@nkr/store/center/hooks/use-center-base-list";
import { ChangeEvent } from 'react';

type TProps = {
    unselectedText: string,
    value: string,
    className: string,
    filter?: { isMemberCenter?: boolean, isLiverParticipant?: boolean, isAdvReimburseEnabled?: boolean },
    onChange?: (centerId: string) => void,
    onChangeFull?: (centerId: string, centerAlias: string) => void
}

const CenterDropDown = ({ unselectedText, value, className, filter, onChange, onChangeFull }: TProps) => {
    const { list, loading, error } = useCenterBaseList();

    if (error) {
        return (<div className={className}>{error}</div>);
    }

    const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
        if (onChange) {
            onChange(e.target.value);
        }

        if (onChangeFull) {
            let d = list.find(x => x.id == parseInt(e.target.value));
            onChangeFull(e.target.value, d.alias);
        }
    }

    const filteredList = list.filter(item => {
        let memberCenterFilter = filter && filter.isMemberCenter != null ? item.isMemberCenter == filter.isMemberCenter : true;
        let liverParticipantFilter = filter && filter.isLiverParticipant != null ? item.isLiverParticipant = filter.isLiverParticipant : true;
        let advReimburseEnabledFilter = filter && filter.isAdvReimburseEnabled != null ? item.isAdvReimburseEnabled = filter.isAdvReimburseEnabled : true;

        return memberCenterFilter && liverParticipantFilter && advReimburseEnabledFilter;
    })

    const options = filteredList.map((l, i) => <option key={i} value={l.id}>{l.alias}</option>);

    return (
        <select className={className} value={value} onChange={handleChange}>
            <option value="">{unselectedText}</option>
            {options}
        </select>
    );
}

export default CenterDropDown;